import React, { useState, useRef, useEffect } from "react";
import { Download, X } from "lucide-react";

function ModalToggleComponents({
     openModal, 
     loading, 
     handleCloseModal, 
     obsequioSelected,
     handleApiActivarObsequio,
     handleApiDesactivarObsequio
     }) {




    return (
        <>
            {openModal && (
                <div
                    className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
                    onClick={(e) => e.target === e.currentTarget && handleCloseModal()}
                >
                    <div className="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl">
                        {/* Header */}
                        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
                            <h2 className="text-base font-bold text-gray-800">
                                {obsequioSelected?.titulo}
                            </h2>
                            <button
                                type="button"
                                aria-label="cerrar"
                                onClick={handleCloseModal}
                                className="rounded-lg p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
                            >
                                <X size={20} />
                            </button>
                        </div>

                        {/* Contenido del modal */}
                        <div className="px-6 py-4">
                            <p className="text-sm text-gray-700 mb-2">
                                ¿Estás seguro que deseas {obsequioSelected?.activo ? "desactivar" : "activar"} este obsequio?
                            </p>
                            <p className="text-sm text-gray-500">
                                Esta acción {obsequioSelected?.activo ? "desactivará" : "activará"} el obsequio y no podrá ser redimido por los usuarios.
                            </p>
                        </div>

                        {/* Footer */}
                        <div className="border-t border-gray-100 px-6 py-4">
                            <button
                                type="button"
                                onClick={()=> {
                                    if(obsequioSelected?.activo) {
                                        handleApiDesactivarObsequio();
                                    } else {
                                        handleApiActivarObsequio();
                                    }
                                }}
                                disabled={loading}
                                className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#104063] py-2.5 font-semibold text-white transition-colors hover:bg-[#0d3553] disabled:cursor-not-allowed disabled:opacity-70"
                            >
                                {loading ? (
                                    <>
                                        <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                                        Cargando...
                                    </>
                                ) : (
                                    <>
                                        {obsequioSelected?.activo ? "Desactivar" : "Activar"}
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}


        </>
    );
}

export default ModalToggleComponents;
